import { useEffect, useRef } from 'react';

import { useBridgeApi } from '@/api/BridgeApi.ts';

export const useEnsureSetupSnapshot = (
	processId: string | null | undefined,
): void => {
	const bridgeApi = useBridgeApi();
	const loadRequestedRef = useRef(false);
	useEffect(() => {
		if (!processId) return;
		const snapshot = bridgeApi.user_state?.process_setup_snapshots?.[processId];
		const error = bridgeApi.user_state?.process_setup_errors?.[processId];
		if (snapshot || error || loadRequestedRef.current) return;
		loadRequestedRef.current = true;
		bridgeApi.sendAction({
			type: 'do_load_setup_snapshot',
			process_id: processId,
		});
	}, [bridgeApi, processId]);
};
